import { getDictSync } from "./getDict.js";
function getDictLabelSync(code, dictName) {
  var _a;
  if (!code)
    return "";
  const dict = getDictSync(dictName);
  const find = (_a = dict.value) == null ? void 0 : _a.find((d) => d.value === code);
  if (find) {
    return find.label;
  } else {
    return code;
  }
}
export { getDictLabelSync };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/getDictLabel.js